import { render, staticRenderFns } from "./BusinessNameDataUpdateFormFiles.vue?vue&type=template&id=bea13da8&scoped=true&"
import script from "./BusinessNameDataUpdateFormFiles.vue?vue&type=script&lang=js&"
export * from "./BusinessNameDataUpdateFormFiles.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameDataUpdateFormFiles.vue?vue&type=style&index=0&id=bea13da8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea13da8",
  null
  
)

export default component.exports